import React, { Component } from 'react';
import { formatIntCurrency } from '../../helpers/format';
import { DEFAULT_SUPPLIER_THUMBNAIL } from '../../helpers/suppliers';
import { Hit } from '../../rpc/admin/search_pb';
import { Link } from 'react-router-dom';
import ProductImage from '../images/product_image';

interface SearchResultProps {
    hit: Hit;
    basePath: string;
}

interface SearchResultState { }

class SearchResult extends Component<SearchResultProps, SearchResultState> {

    render() {
        const link = this.props.basePath + encodeURIComponent(this.props.hit!.getSku());
        const thumbnail = this.props.hit!.getThumbnail() ? this.props.hit!.getThumbnail() : DEFAULT_SUPPLIER_THUMBNAIL;

        return (
            <li className="media search-result">
                <figure className="media-left">
                    <p className="image is-128x128">
                        <Link to={link}>
                            <img
                                src={ProductImage.imageUrl(thumbnail)}
                                alt={this.props.hit!.getName()}
                            />
                        </Link>
                    </p>
                </figure>
                <div className="media-content">
                    <div className="content">
                        <div className="is-size-7">
                            <strong className="is-size-6 title-snippet">
                                <Link to={link}>
                                    {this.props.hit!.getName()}
                                </Link>
                            </strong>
                            {" "}
                            <div className="is-italic manufacturer-snippet">
                                by {this.props.hit!.getManufacturer()}
                            </div>
                            <div className="is-italic category-snippet">
                                in {this.props.hit!.getCategory()}
                            </div>
                            <div className="description-snippet">
                                {this.props.hit!.getSnippet()}
                            </div>
                            <div className="in-stock-snippet has-text-weight-bold">{this.props.hit!.getQoh()} in stock</div>
                        </div>
                    </div>
                </div>
                <div className="media-right">
                    <div className="price-snippet has-text-weight-bold">
                        {formatIntCurrency(this.props.hit!.getPrice())}
                    </div>
                </div>
            </li>
        );
    }
}

export default SearchResult;